import React, { useState } from 'react'
import FlyBtn from '../Menu/FlyBtn';
import { useSelector } from 'react-redux';
import { IMAGE_URL } from '../../Components/client-config';
import { toast } from 'react-toastify';
import _ from 'lodash';
import SelectStoreModal from '../../Components/selectStoreModal';
import JazzCashOnly from '../../Components/JazzCashOnly';
import { useTranslation } from 'react-i18next';
import { itemReady } from '../../utils/productValidations';
import { renderMenuPriceDisplay } from '../../utils/menu.utils';

export default function SuggestiveItems(props: any) {
  const crossSellItems = useSelector((state: any) => state.menu.crossSellItems);
  const cartData = useSelector((state: any) => state.cart.cartData);
  const storeSelected = useSelector((state: any) => state.store.storeSelected);
  const [selectStoreShow, setSelectStoreModal] = useState(false);
  const handleSelectStoreClose = () => setSelectStoreModal(false);
  const [selectJCShow, setSelectJCModal] = useState(false);
  const [itemJS, setItemJS] = useState(false);
  const { t } = useTranslation();

  const handleSelectJSToogle = () => {
    if (itemJS) {
      setSelectJCModal((prev) => {
        return !prev
      })
    }
  } 
  function handleAdd(item: any) {
    if (_.isEmpty(storeSelected)) {
      setSelectStoreModal(true)
    }
    if (item.menu_item_id > 0) {
      let selectedSize = item.item_size[0];
      let initialPrice = Number(((selectedSize.discount_price || selectedSize.discount_price == 0) && (selectedSize.order_channel == 'online')) ? Number(selectedSize.discount_price) : Number(selectedSize.mrp));
      let itemPrice = Number((selectedSize.discount_price || selectedSize.discount_price == 0) && (selectedSize.order_channel == 'online')) ? Number(selectedSize.discount_price) : Number(selectedSize.mrp)
      let discounted_item: any = false;
      let cart: any = cartData;
      if (item.item_size && item.item_size[0].is_jazz_cash === 1) {
        setItemJS(true)
      }
      if ((item.item_size[0].discount_price || item.item_size[0].discount_price == 0) && (item.item_size[0].order_channel == "all" || item.item_size[0].order_channel == "online")) {
        discounted_item = true;
      } else {
        discounted_item = false;
      }

      if (!_.isEmpty(cart)) {
        let found = false;

        cart.forEach((element: any) => {
          if (element["item"]) {
            if (element["item"].menu_item_id == item.menu_item_id) {
              if (item.item_size[0].size == element.selectedsize.size) {
                element.quantity = element.quantity + 1;
                let itemNetPrice = ((item.item_size[0].discount_price || item.item_size[0].discount_price == 0) && item.item_size[0].order_channel == 'online') ? Number(item.item_size[0].discount_price) : Number(item.item_size[0].mrp)
                element.totalItemPrice = itemNetPrice + element.totalItemPrice;
                found = true
              }
            }
          }
        });
        if (!found) {
          const itemcart = {
            item: item,
            quantity: 1,
            selectedsize: selectedSize,
            price: Number(initialPrice),
            totalItemPrice: Number(itemPrice),
            modifiers: item.modifiers,
            collapseIn: false
          };
          cart.push(itemcart);
        }
      } else {
        const itemcart = {
          item: item,
          quantity: 1,
          selectedsize: selectedSize,
          price: Number(initialPrice),
          totalItemPrice: Number(itemPrice),
          modifiers: item.modifiers,
          collapseIn: false
        };
        cart.push(itemcart);
      }

      props.saveCart(cart);
      if (storeSelected) {
        toast.success(`${item.item_name} ${t("ADDED_TO_CART")}`, {
          position: toast.POSITION.TOP_RIGHT,
          hideProgressBar: true,
          autoClose: 3000
        });
      }
      // }
    }
    props.setValue(props.value + 1)

  };
  return (
    <>
      {crossSellItems && crossSellItems.length > 0 && crossSellItems.filter((item: any) => {
        return !cartData.some((obj: any) => obj.item && obj.item.menu_item_id == item.menu_item_id)
      }).length > 0 && <h4 className='suggestive-head-text'>{t("YOU_MAY_ALSO_LIKE")}</h4>}
      <div className='suggestive-items'>
        {
          (crossSellItems && crossSellItems.length > 0) &&
          crossSellItems.filter((item: any) => {
            return !cartData.some((obj: any) => obj.item && obj.item.menu_item_id == item.menu_item_id)
          }).map((obj: any, index: any) => {
            return (
              <div className={`card card-contaier ${!obj.is_publish || obj.is_snooze || obj.item_close_flag ? "disableShadow" : ""}`}>
                <img src={`${IMAGE_URL}${obj.item_size[0].image_url}`} className="card-img-top" alt={obj.item_size[0].alt_text ? obj.item_size[0].alt_text : obj?.item_name} />
                <div className="card-body p-2">
                  <h5 className="card-title suggestive-title">{obj?.item_name} { !!obj.item_size?.[0]?.size && "(" + obj.item_size[0].size + ")"}</h5>
                  <div className='d-flex justify-content-between align-items-center  mt-2'>
                    <p className="card-text suggestive-price mb-0 suggestive-price-algeria">{renderMenuPriceDisplay(obj)}</p>
                    <div className='fly-btn  suggestive-price-flybtn-algeria'>
                      <FlyBtn itemReady={itemReady} product={obj} handleAdd={handleAdd} handleToogle={handleSelectJSToogle} />
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        }
        <SelectStoreModal show={selectStoreShow} handleClose={handleSelectStoreClose} />
        <JazzCashOnly show={selectJCShow} handleToogle={handleSelectJSToogle} />
      </div>
    </>
  )
}
